export default __webpack_public_path__ + "static/media/vinyl-bottom-layer.82d9f6ef.svg";